import React from "react";
import { Drawer, List, ListItem, ListItemText, Divider, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";


const MenuComponent = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleMenuItemClick = (route) => {
    navigate(route); // Navigate to the passed route
    onClose(); // Close the drawer after clicking
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        width: 250,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 250,
          backgroundColor: "#1C1468", // Custom background color
          color: "#fff", // Text color
          paddingTop: "20px",
        },
      }}
    >
      <Box sx={{ paddingLeft: "20px", paddingBottom: "20px", display: "flex", alignItems: "center" }}>
        {/* Logo Section */}
        <img src={`/images/nucleusx.png`} alt="Logo" style={{ width: "100px", height: "auto" }} />
      </Box>

      <List sx={{ marginTop: "20px" }}>
        {/* Settings Section */}
        <ListItem button onClick={() => handleMenuItemClick("/contacts")}>
          <ListItemText
            primary="Contacts"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3c1f7c", // Hover effect
              },
            }}
          />
        </ListItem>

        {/* Documents Section */}
        <ListItem button onClick={() => handleMenuItemClick("/documents")}>
          <ListItemText
            primary="Documents"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3c1f7c", // Hover effect
              },
            }}
          />
        </ListItem>

        <ListItem button onClick={() => handleMenuItemClick("/documents/company-policies")}>
          <ListItemText
            primary="Health & Safety"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3c1f7c", // Hover effect
              },
            }}
          />
        </ListItem>

        {/* Divider */}
        <Divider sx={{ borderColor: "#fff", marginY: "10px" }} />

        {/* Additional menu items can go here */}
        <ListItem button onClick={() => handleMenuItemClick("/other")}>
          <ListItemText
            primary="Other Menu Item 1"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3c1f7c", // Hover effect
              },
            }}
          />
        </ListItem>
        {/* Additional menu items can go here */}
        <ListItem button onClick={() => handleMenuItemClick("/other")}>
          <ListItemText
            primary="Other Menu Item 2"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3c1f7c", // Hover effect
              },
            }}
          />
        </ListItem>
        {/* Additional menu items can go here */}
        <ListItem button onClick={() => handleMenuItemClick("/other")}>
          <ListItemText
            primary="Other Menu Item 3"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3c1f7c", // Hover effect
              },
            }}
          />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default MenuComponent;